import React, { Component } from "react";
import styles from "./trips.module.scss";
import TripControlPointVariationMap from "./TripControlPointVariationMap";
import { withLogisticTripControlPoints } from "../../../shared/containers/containerLogisticTripControlPoints";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { TextField } from "@mui/material";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";

class TripControlPointVariation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      controlPointVariation: props.controlPoint,
      isChange: false,
    };
  }

  onCloseClick() {
    const { onSetControlPointVariation } = this.props;
    onSetControlPointVariation(null, null);
  }

  onHandleChangeStore(name, value, number = false) {
    const { controlPointVariation } = this.state;

    controlPointVariation[name] = number ? parseInt(value === "" || value === null ? (name === "radius" ? "1" : "0") : value) : value;
    this.setState({ controlPointVariation: controlPointVariation, isChange: true });
  }

  onSaveHandler() {
    const { onUpdateLogisticControlPointVariation, tripId, routeId } = this.props;
    const { controlPointVariation } = this.state;

    onUpdateLogisticControlPointVariation({
      tripId,
      routeId,
      controlPointId: controlPointVariation.id,
      radius: controlPointVariation.radius,
      maxSpeed: controlPointVariation.maxSpeed,
    });

    this.setState({ isChange: false });
  }

  render() {
    const { controlPointVariation, isChange } = this.state;
    const height = window.innerHeight > 800 ? 650 : 450;

    return (
      <div className={styles.tripControlPointVariationContainer} style={{ height: `${height}px` }}>
        <div style={{ minWidth: "60%" }}>
          <TripControlPointVariationMap
            key={`${controlPointVariation.id}${controlPointVariation.radius}`}
            controlPoint={controlPointVariation}
            height={height}
          />
        </div>

        <div className={styles.parmsContainer}>
          <div
            className={styles.rigthPanel}
            onClick={() => {
              this.onCloseClick();
            }}
          >
            <TooltipWrapper title={"Закрыть"} position="left">
              <HighlightOffIcon style={{ color: "red" }} />
            </TooltipWrapper>
          </div>

          <div className={styles.paramLabel}>
            <b>Порядковый номер в рейсе:</b> <span>{this.props.number}</span>
          </div>

          <div className={styles.paramLabel}>
            <b>Наименование:</b> <span>{controlPointVariation.title}</span>
          </div>

          <div className={styles.paramLabel}>
            <b>Адрес:</b> <span>{controlPointVariation.address}</span>
          </div>

          <div className={styles.paramLabel}>
            <b>Адрес по локации:</b> <span>{controlPointVariation.geocoderAddress}</span>
          </div>

          <div>
            <TextField
              id="outlined-basic"
              label="Радиус (м)"
              variant="outlined"
              size="small"
              type="number"
              InputProps={{
                sx: { width: "300px" },
                inputProps: { min: 1 },
              }}
              value={controlPointVariation.radius}
              onChange={(e) => {
                this.onHandleChangeStore("radius", e.target.value, true);
              }}
            />
          </div>

          <div>
            <TextField
              id="outlined-basic"
              label="Максимальная засчитываемая скорость (км./ч.)"
              variant="outlined"
              size="small"
              type="number"
              InputProps={{
                sx: { width: "300px" },
                inputProps: { min: 0 },
              }}
              value={controlPointVariation.maxSpeed}
              onChange={(e) => {
                this.onHandleChangeStore("maxSpeed", e.target.value, true);
              }}
            />
          </div>
          {isChange ? <ButtonPrimary title={"Обновить"} handleClick={this.onSaveHandler.bind(this)}></ButtonPrimary> : null}
        </div>
      </div>
    );
  }
}

export default withLogisticTripControlPoints(React.memo(TripControlPointVariation));
